import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseRemoveIcon = ({ className }: IProps) => (
    <svg
        className={className}
        fill="black"
        height="11px"
        viewBox="0 0 48 48"
        width="11px"
    >
        <path d="M30.7882 24L46.5931 8.19509C48.469 6.31927 48.469 3.28269 46.5931 1.40687C44.7173 -0.468956 41.6807 -0.468956 39.8049 1.40687L24 17.2118L8.19509 1.40687C6.31927 -0.468956 3.28269 -0.468956 1.40687 1.40687C-0.468956 3.28269 -0.468956 6.31927 1.40687 8.19509L17.2118 24L1.40687 39.8049C-0.468956 41.6807 -0.468956 44.7173 1.40687 46.5931C2.34723 47.5286 3.57165 47.9988 4.80098 47.9988C6.0303 47.9988 7.25473 47.5286 8.19509 46.5931L24 30.7882L39.8049 46.5931C40.7404 47.5286 41.9697 47.9988 43.199 47.9988C44.4283 47.9988 45.6528 47.5286 46.5931 46.5931C48.469 44.7173 48.469 41.6807 46.5931 39.8049L30.7882 24Z" />
    </svg>
);

export const RemoveIcon = styled(BaseRemoveIcon)``;
